
import Vue from "vue";
/** @remarks
 * for iOS safari, it's toolbar overlaps viewport with 100vh
 */
export default Vue.extend({
  name: "layout-ios-safari-overlap-toolbar",
  props: {
    extraHeight: {
      type: Number,
      default: 1,
    },
  },
});
